import { createFileRoute } from '@tanstack/react-router'
import { Checkout, CheckoutLayout } from 'merchant-components'

export const Route = createFileRoute('/application/$id/checkout')({
  component: () => <CheckoutLayout outlet={<Checkout />} />
})

